import { getProvider } from '../../../apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const transaction = 'lockSimCard'

const initialState = {
  status: ''
}

const PassivateSimCardModule = {
  namespaced: true,
  state: initialState,
  getters: {
    currentStatus: state => state.status
  },
  actions: {
    async requestLockSimCard ({ commit, state, getters, rootGetters }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation ${transaction} {
          passivateSimCard {
            success
            status
          }
        }`
      }).then((response) => {
        commit('Transaction/removeTransactionId', transaction, { root: true })
        if ((response.data.passivateSimCard.success === true)) {
          commit('changeStatus', 'running')
        } else if ((response.data.passivateSimCard.success === false) && (response.data.passivateSimCard.status === 'running')) {
          commit('changeStatus', 'running')
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        throw error
      })
    }
  },
  mutations: {
    changeStatus: (state, status) => {
      state.status = status
    }
  }
}

export {
  PassivateSimCardModule
}
